import { render, staticRenderFns } from "./tel-confirm-distribution.vue?vue&type=template&id=0a1676f0&scoped=true"
import script from "./tel-confirm-distribution.vue?vue&type=script&lang=ts"
export * from "./tel-confirm-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1676f0",
  null
  
)

export default component.exports